export default "{\n    \"poweredByResq\": \"Propulsé par ResQ\"\n}\n"